import { useInvalidateReviews } from '@/entities/review';
import { trpc } from '@/shared/api';
import { useAsyncAction } from '@/shared/lib';

export const useHideReview = () => {
  const mutation = trpc.reviewManagement.hide.useMutation();
  const action = useAsyncAction(mutation.mutateAsync, useInvalidateReviews());
  return { ...action, hide: action.execute };
};
